/* eslint-disable no-trailing-spaces */
/* eslint-disable no-unused-vars */
import React from 'react';

export default {
  default: {
    price: 'Price',
    amount: 'Amount',
    total: 'Total',
    stop_price: 'Stop price',
    price_limit: 'Limit',
    address: 'Address',

    // src/components/AppComponent.js
    'navigation.home_link': 'TrustKeys',
    'navigation.exchange_link': 'Exchange',
    'navigation.explore': 'Explore',
    'navigation.referral': 'Referral',
    'navigation.campaign': 'Campaign',
    'navigation.language_link': 'Language',
    'navigation.language_sub_en_link': 'English',
    'navigation.language_sub_vi_link': 'Tiếng Việt',
    'navigation.language_sub_korea_link': 'Korea',
    'navigation.sign_out_link': 'Sign out',
    'navigation.login_link': 'Login',
    'navigation.wallet_link': 'Wallet',
    'navigation.qa_link': 'Q&A',
    'navigation.tutorial': 'Tutorial',
    'navigation.create_account': 'Create Account',
    'navigation.create_account_sign_in': 'Sign in',
    'navigation.create_account_sign_up': 'Sign up',

    'landing.name': 'Name',
    'landing.last_price': 'Last price',
    'landing.change_24h': 'Change 24h',
    'landing.high': 'High price',
    'landing.low': 'Low price',
    'landing.volume': 'Volume 24h',

    'landing.text_1': 'Secure crypto exchange',
    'landing.text_2': 'Join the safest and fastest crypto exchange to buy & sell',
    'landing.text_3': 'Start',
    'landing.text_4': 'Download App TrustKeys',

    'landing.contact_us': 'Contact us',
    'landing.preferential_exchange': 'Preferential Exchange',
    'landing.new_trading_experience': 'Enhance your trading capabilities with a new trading experience',
    'landing.check_now': 'Check Now',
    'landing.support_24_7': 'Support 24/7',
    'landing.problem': 'Are you having problems? Contact us right away. Team support of TrustKeys is available 24/7',
    'landing.blog': 'TrustKeys Blog',
    'landing.news': 'News and updates from the world\'s leading cryptocurrency exchange',
    'landing.community': 'Community',
    'landing.join_us': 'Join our community around the world for instant discussions',
    'landing.condition': 'What are the conditions for doing with TrustKeys Exchange?',
    'landing.more': 'More >',

    'footer.about_us': 'About us',
    'footer.more_info': 'More info',
    'footer.blog': 'TrustKeys Blog',
    'footer.community': 'Community',
    'footer.product': 'Products',
    'footer.network': 'TrustKeys Network',
    'footer.social': 'Butta Social network',
    'footer.download_here': 'Download app here',

    'language.vi': 'Vietnamese',
    'language.en': 'English',

    'login.qr_success': 'Code scan was successful. Please select "Confirm" on your mobile device.',
    'login.login_trustkeys': 'Sign in with your TrustKeys account',
    'login.new_qr': 'Get new QR',
    'login.download_app': 'Download mobile app',
    'login.with_qr': 'Login with QR code',

    'login.not_have_account': 'Do not have an account?',
    'login.download_trustkeys': 'Download the TrustKeys app now!',

    //
    'exchange.exchange_select.your_balance': 'YOUR BALANCE',
    'exchange.exchange_select.available': 'AVAILABILITY',
    'exchange.exchange_select.value': 'VALUE',
    'exchange.exchange_select.my_account': 'MY ACCOUNT',
    'exchange.exchange_select.dashboard': 'Dashboard',
    'exchange.exchange_select.user_info': 'User Info',
    'exchange.exchange_select.logout': 'Log Out',
    'exchange.exchange_select.gender': 'Gender',
    'exchange.exchange_select.lock': 'Lock',
    'exchange.exchange_select.date_of_birth': 'Date Of Birth',
    'exchange.exchange_select.setting': 'SETTINGS',
    'exchange.exchange_select.light_theme': 'Light theme',
    'exchange.exchange_select.fast_order_book': 'Fast order book',
    'exchange.exchange_select.show_open_orders': 'Show open orders',
    'exchange.exchange_select.show_indicators': 'Sound indicators',
    'exchange.exchange_select.quick_overview': 'QUICK OVERVIEW',
    'exchange.exchange_select.main': 'main',
    'exchange.exchange_select.total_balance': 'Total balance',

    'exchange.order_buy_limit.available': 'Available',
    'exchange.order_buy_limit.price_field_is_required': 'Price field is required',
    'exchange.order_buy_limit.price': 'Price',
    'exchange.order_buy_limit.amount_field_is_required': 'Amount field is required',
    'exchange.order_buy_limit.amount': 'Amount',
    'exchange.order_buy_limit.total_field_is_required': 'Total field is required',
    'exchange.order_buy_limit.total': 'Total',
    'exchange.order_buy_limit.buy': 'Buy',

    'exchange.order_sell_limit.available': 'Available',
    'exchange.order_sell_limit.price_field_is_required': 'Price field is required',
    'exchange.order_sell_limit.price': 'Price',
    'exchange.order_sell_limit.amount_field_is_required': 'Amount field is required',
    'exchange.order_sell_limit.amount': 'Amount',
    'exchange.order_sell_limit.total_field_is_required': 'Total field is required',
    'exchange.order_sell_limit.total': 'Total',
    'exchange.order_sell_limit.sell': 'Sell',

    'exchange.order_market.available': 'Available',
    'exchange.order_market.amount_field_is_required': 'Amount field is required',
    'exchange.order_market.amount': 'Amount',
    'exchange.order_market.buy': 'Buy',
    'exchange.order_market.sell': 'Sell',

    'exchange.order_stop_limit.available': 'Available',
    'exchange.order_stop_limit.stop_field_is_required': 'Stop field is required',
    'exchange.order_stop_limit.stop': 'Stop',
    'exchange.order_stop_limit.limit_field_is_required': 'Limit field is required',
    'exchange.order_stop_limit.limit': 'Limit',
    'exchange.order_stop_limit.amount_field_is_required': 'Amount field is required',
    'exchange.order_stop_limit.amount': 'Amount',
    'exchange.order_stop_limit.total_field_is_required': 'Total field is required',
    'exchange.order_stop_limit.total': 'Total',
    'exchange.order_stop_limit.buy': 'Buy',
    'exchange.order_stop_limit.sell': 'Sell',

    'exchange.order_confirm_question': 'Are you sure you want to make the transaction?',

    'exchange.right_panel.start_trading': 'START TRADING',
    'exchange.right_panel.login': 'Login',
    'exchange.right_panel.welcome_sonek': 'Welcome to TrustKeys Network cryptocurrency exchange',
    'exchange.right_panel.the_exchange': "The world's newest cryptocurrency exchange.",
    'exchange.right_panel.we_through': 'We provide premium access to cryptocurrency trading for both individuals and institutional clients through:',
    'exchange.right_panel.slogan': 'The perfect combination of "Secure personal wallet" with "Safe and fast exchange"',
    'exchange.right_panel.volume_based_structure': 'Volume-based fee structure',
    'exchange.right_panel.high_engine': 'High performance matching engine',
    'exchange.right_panel.fix,_connectivity': 'FIX, Websocket and HTTP API connectivity',
    'exchange.right_panel.24/7_support': '24/7 service and dedicated premium support',
    'exchange.right_panel.industry_leading_practices': 'Industry-leading security practices',
    'exchange.right_panel.new_order': 'New Order',
    'exchange.right_panel.market': 'Market',
    'exchange.right_panel.limit': 'Limit',
    'exchange.right_panel.stop': 'Stop',
    'exchange.right_panel.sell': 'Sell',
    'exchange.right_panel.buy': 'Buy',

    'exchange.order_book.price': 'Price',
    'exchange.order_book.amount': 'Amount',
    'exchange.order_book.total': 'Total',
    'exchange.order_book.sum': 'Sum',

    'exchange.order_transaction.amount': 'Amount',
    'exchange.order_transaction.time': 'Time',
    'exchange.order_transaction.price': 'Price',

    'user.menu.user_security': 'User Security',
    'user.menu.user_wallet': 'User Wallet',
    'user.menu.deposit': 'Deposit',
    'user.menu.withdrawal': 'Withdrawal',
    'user.menu.deposit_history': 'Deposit & Withdrawal',
    'user.menu.open_orders': 'Open Orders',
    'user.menu.order_trans_history': 'Order Transaction History',
    'user.menu.user_login_history': 'User Login History',
    'user.menu.order_history': 'Order History',
    'user.menu.commission_history': 'Referral',

    'user.account_balance.coin': 'Coin',
    'user.account_balance.name': 'Name',
    'user.account_balance.balance': 'Balance',
    'user.account_balance.available_balance': 'Available Balance',
    'user.account_balance.action': 'Action',
    'user.account_balance.deposit': 'Deposit',
    'user.account_balance.withdrawal': 'Withdrawal',
    'user.account_balance.account': 'Account',
    'user.account_balance.estimated_value': 'Estimated Value',
    'user.account_balance.24h_limit': '24h Withdrawal Limit',
    'user.account_balance.unlimited': 'Unlimited',
    'user.account_balance.hide_assets': 'Hide low balance assets',
    'user.account_balance.coin_search': 'Coin search',

    'user.deposit.deposit': 'Deposit',
    'user.deposit.coin': 'Coin',
    'user.deposit.total_balance': 'Total balance',
    'user.deposit.copy': 'Successfully copied',
    'user.deposit.available_balance': 'Available balance',
    'user.deposit.tips': 'Tips',
    'user.deposit.coins_confirmations': 'Coins will be deposited after 1 network confirmations',
    'user.deposit.until_withdrawals': 'Until 2 confirmations are made, an equivalent amount of your assets will be temporarily unavailable for withdrawals',
    'user.deposit.go_trade': 'Go to Trade',
    'user.deposit.select_network': 'Select Network',
    'user.deposit.address': '{{coinSymbol}} Address',
    'user.deposit.pubkey': 'Pubkey {{pubkey}}',
    'user.deposit.recent_history': 'Recent Deposit History',
    'user.deposit.show_qr': 'Show QR Code',
    'user.deposit.send_only_addr': 'Send only {{coinSymbol}} to this deposit address.',
    'user.deposit.send_deposit': 'Sending coin or token other than {{coinSymbol}} to this address may result in the loss of your deposit.',
    'user.deposit.currency': 'Currency',
    'user.deposit.copy_address': 'Copy address',
    'user.deposit.fee': 'Fee',
    'user.deposit.amount': 'Amount',
    'user.deposit.status': 'Status',
    'user.deposit.deposit_date': 'Date',
    'user.deposit.modal_title': 'QR code {{coinSymbol}} deposit address',
  
    'user.transaction.id': 'ID',
    
    'user.withdrawal.withdrawal': 'Withdrawal',
    'user.withdrawal.coin': 'Coin',
    'user.withdrawal.total_balance': 'Total balance',
    'user.withdrawal.tips': 'Tips',
    'user.withdrawal.coins_confirmations': 'Coins will be deposited after 1 network confirmations.',
    'user.withdrawal.until_withdrawals': 'Until 2 confirmations are made, an equivalent amount of your assets will be temporarily unavailable for withdrawals.',
    'user.withdrawal.go_trade': 'Go to Trade',
    'user.withdrawal.select_network': 'Select Network',
    'user.withdrawal.average': 'Average',
    'user.withdrawal.fast': 'Fast',
    'user.withdrawal.fastest': 'Fastest',
    'user.withdrawal.submit': 'Submit',
    'user.withdrawal.send_address': 'Send only {{coinSymbol}} to this deposit address.',
    'user.withdrawal.sending_deposit': 'Sending coin or token other than {{coinSymbol}} to this address may result in the loss of your deposit.',
    'user.withdrawal.minimum_withdrawal': 'Minimum Withdrawal',
    'user.withdrawal.available_balance': 'Available Balance',
    'user.withdrawal.transaction_fee': 'Transaction Fee',
    'user.withdrawal.you_get': 'You Will Get',
    'user.withdrawal.you_pay': 'You Must Pay',
    'user.withdrawal.recent_history': 'Recent Withdrawal History',
    'user.withdrawal.currency': 'Currency',
    'user.withdrawal.fee': 'Fee',
    'user.withdrawal.amount': 'Amount',
    'user.withdrawal.status': 'Status',
    'user.withdrawal.withdrawal_date': 'Date',
    'user.withdrawal.question': 'Are you sure you want to make a transaction?',
    'user.withdrawal.label_receive_address': 'Recipient \'s {{coinSymbol}} address:',
    'user.withdrawal.label_pubkey': 'Recipient \'s pubkey:',
    'user.withdrawal.detail': 'Detail',

    'user.deposit_and_withdrawal.currency': 'Currency',
    'user.deposit_and_withdrawal.fee': 'Fee',
    'user.deposit_and_withdrawal.amount': 'Amount',
    'user.deposit_and_withdrawal.status': 'Status',
    'user.deposit_and_withdrawal.deposit_history': 'Deposit & Withdrawal History',
    'user.deposit_and_withdrawal.transfer': 'Transfer',
    'user.deposit_and_withdrawal.deposits': 'Deposits',
    'user.deposit_and_withdrawal.withdrawal': 'Withdrawal',
    'user.deposit_and_withdrawal.coin': 'Coin',
    // 'user.deposit_and_withdrawal.status': 'Status',
    'user.deposit_and_withdrawal.all': 'ALL',
    'user.deposit_and_withdrawal.completed': 'Completed',
    'user.deposit_and_withdrawal.success': 'Success',
    'user.deposit_and_withdrawal.pending': 'Pending',
    'user.deposit_and_withdrawal.submitted': 'Submitted',
    'user.deposit_and_withdrawal.error': 'Error',
    'user.deposit_and_withdrawal.cancel': 'Cancel',
    'user.deposit_and_withdrawal.rejected': 'Reject',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_date': 'Date',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_start_date': 'Start date',
    'user.deposit_and_withdrawal.deposit_and_withdrawal_end_date': 'End date',
    'user.deposit_and_withdrawal.type': 'Type',

    'user.open_order.id': 'Id Order',
    'user.open_order.open_order': 'Open Orders',
    'user.open_order.order_type': 'Order Type',
    'user.open_order.transfer': 'Type',
    'user.open_order.pair': 'Pair',
    'user.open_order.withdrawal': 'Price',
    'user.open_order.coin': 'Amount',
    'user.open_order.quantity': 'Quantity',
    'user.open_order.total': 'Total',
    'user.open_order.all': 'Filled',
    'user.open_order.status': 'Status',
    'user.open_order.pending': 'Date',
    'user.open_order.action': 'Action',
    'user.open_order.created_at': 'Date',
    'user.open_order.limit': 'Limit',
    'user.open_order.stop_limit': 'Stop Limit',
    'user.open_order.market': 'Market',
    'user.open_order.sell': 'Sell',
    'user.open_order.buy': 'Buy',
    'user.open_order.cancel_all': 'Cancel all',

    'user.order_trans.id': 'Id Order Transaction',

    'user.open_order_exchange.open_order': 'Open Orders',
    'user.open_order_exchange.deposit_history': 'Order',
    'user.open_order_exchange.transfer': 'Type',
    'user.open_order_exchange.deposits': 'Pair',
    'user.open_order_exchange.withdrawal': 'Price',
    'user.open_order_exchange.coin': 'Amount',
    'user.open_order_exchange.total': 'Total',
    'user.open_order_exchange.status': 'Status',
    'user.open_order_exchange.all': 'Filled',
    'user.open_order_exchange.pending': 'Date',
    'user.open_order_exchange.action': 'Action',
    'user.open_order_exchange.title_modal': 'Confirm cancel the order belong to market {{pair}}',
    'user.open_order_exchange.infor_cancel': 'Information cancel order',
    'user.open_order_exchange.order_state': 'Order state',
    'user.open_order_exchange.matching_amount': 'Matched amount',
    'user.open_order_exchange.rest_amount': 'Rest amount',
    'user.open_order_exchange.total_amount_order': 'Total order',
    'user.open_order_exchange.matched_percent': 'Matched percent',

    'user.login_history.agent_title': 'Agent',
    'user.login_history.login_time_title': 'Time',

    'user.order_tran.title': 'Order Transaction History',
    'user.order.title': 'Order History',

    'question_answer.title': 'May I help you',
    'question_answer.placeholder': 'Input keyword...',

    'user.commission_coin': 'Coin',
    'user.commission_coin_value': 'Total',

    'ans_1.text_1': 'What is cryptocurrency?',
    'ans_1.text_2': 'Cryptocurrency is digital money, that is, money in the form of digital bits. Cryptocurrencies are only used in the digital environment for digital payments through information systems including computer networks, Internet and digital means stored in the database of issuer (3rd party). This means, you can\'t handle it and can only be used on electronic media.',
    'ans_1.text_3': 'What coins are currently trading with TrustKeys?',
    'ans_1.text_4': 'Currently, TrustKeys exchange is trading with the currencies: BTC, USDT, KNC, ETH.',
    'ans_1.text_5': 'Advantages and disadvantages of cryptocurrencies?',
    'ans_1.text_6': 'Advantages :',
    'ans_1.text_7': 'Cryptocurrencies are generally considered to be a scientific and technological advance in the monetary and financial field. Therefore, it has certain advantages compared to the current circulating paper currency in the market:',
    'ans_1.text_8': 'Convenience in transactions: If you deposit money at banks, you may be limited to transfer, withdraw money ... in 1 day, with cryptocurrencies, you have the freedom to trade regardless of space, time.',
    'ans_1.text_9': 'Cryptocurrencies cannot be counterfeited: Because they do not exist in physical form, and each cryptocurrency exists under a single sequence of encrypted bits on the Internet.',
    'ans_1.text_10': 'High security, no identity revealed when transactions anonymously.',
    'ans_1.text_11': 'Very low transaction costs.',
    'ans_1.text_12': 'Profitability is very high, especially for small value coins.',
    'ans_1.text_13': 'Safety and environmental protection.',
    'ans_1.text_14': 'Has the potential to develop e-commerce.',
    'ans_1.text_15': 'Disadvantages:',
    'ans_1.text_16': 'Besides the advantages mentioned above, there are still some disadvantages to cryptocurrencies. This causes many difficulties for users such as:',
    'ans_1.text_17': 'Using is not too easy: For those who are used to using technology, this problem is not too difficult. But for those who have little chance of exposure to technology, creating a cryptocurrency wallet and managing it is quite difficult. Not being careful is also deceived easily.',
    'ans_1.text_18': 'Cryptocurrency prices often fluctuate up and down, which is difficult to predict. This is similar to the stock market ups and downs. Traders are at risk of losing or losing capital if they do not regularly monitor fluctuations.',
    'ans_1.text_19': 'As a place for money laundering criminals: Perhaps this is the biggest downside. For the same reason, there are countries that don\'t yet accept coins as legal tender.',
    'ans_1.text_20': 'Hackers are now the primary target of hackers and are also associated with other illegal activities',
    'ans_1.text_21': 'Investing easily leads to financial bubbles on the Internet',
    'ans_1.text_22': 'Should we invest in cryptocurrency?',
    'ans_1.text_23': 'It is difficult to say whether to invest in cryptocurrencies at the moment or not, especially Bitcoin because the latter cryptocurrencies receiving more investment and preparation have surpassed Bitcoin.',
    'ans_1.text_24': 'If you have a small or medium amount of money, you can invest in a currency that has a low market value but is more profitable and faster than a coin of great value.',
    'ans_1.text_25': 'However, cryptocurrency is not an ideal choice for busy people because the price of money is constantly fluctuating. Without regular monitoring, profitability is very low, even losing quickly.',
    'ans_1.text_26': 'So:',
    'ans_1.text_27': 'You SHOULD invest only when you have time to keep track of it because the volatility of cryptocurrencies is huge and need to really understand the currency in which you invest.',
    'ans_1.text_28': 'You SHOULD NOT invest in a movement without fully understanding what cryptocurrency is and how to evaluate the market, because the risk of loss is very high if you do not really understand the currency you invest and know. seize the right opportunity.',

    'ans_2.text_1': 'How can I login to TrustKeys exchange?',
    'ans_2.text_2': 'To buy / sell coin on to trading, first you need to download the TrustKeys app, create an account to be able to login.',
    'ans_2.text_3': 'Link to download on IOS:',
    'ans_2.text_4': 'Link to download on Android:',
    'ans_2.text_5': 'After you finish downloading the app, you can recharge your wallet and scan the QR code for coin purchases.',
    'ans_2.text_6': 'How can I trade / buy coins?',
    'ans_2.text_7': 'You need to make sure the balance in your wallet is enough for you to trade on the exchange, for TrustKeys exchange, you can trade at least 0.0001 BTC. Then, you can order coins with the desired market.',
    'ans_2.text_8': 'How can I make a deposit / withdrawal transaction?',
    'ans_2.text_9': 'To withdraw coins, you need to enter the amount to withdraw and enter the address where the account will receive the money, there are two ways that you scan the QR code or paste the address of the recipient, so you can withdraw. safely.',
    'ans_2.text_10': 'To make a deposit, simply scan the QR code or paste your address to be able to top up.',

    'ans_3.text_1': 'How to invite your friends to join trading?',
    'ans_3.text_2': 'Very simply, you can send your information in the category "Add friends" on the app, click "Share now" to the friend you want to send.',
    'ans_3.text_3': 'What are the benefits of inviting friends to use the platform?',
    'ans_3.text_4': 'If you invite friends to use TrustKeys, you will enjoy commissions and utilities that you cannot imagine. When introducing a friend to use the TrustKeys platform, you will enjoy 30% of the transaction fee when the person you invite to make transactions on the TrustKeys exchange. In addition, you will receive 20% transaction fee on another person\'s trading if your friend refers that person. Quickly invite your friends to join the TrustKeys exchange!',

    'ans_4.text_1': 'Is TrustKeys safe?',
    'ans_4.text_2': 'When trading with TrustKeys, you can safely and smartly buy / sell coins, TrustKeys use extremely secure encryption algorithms, so you can feel secure when making transactions on the TrustKeys exchange. .',
    'ans_4.text_3': 'What currencies are currently traded on the TrustKeys exchange?',
    'ans_4.text_4': 'Currently, TrustKeys exchange is trading with the currencies: BTC, USDT, KNC, ETH.',
    'ans_4.text_5': 'Advantages and disadvantages of cryptocurrencies?',
    'ans_4.text_6': 'Advantages :',
    'ans_4.text_7': 'Cryptocurrencies are generally considered to be a scientific and technological advance in the monetary and financial field. Therefore, it has certain advantages compared to the current circulating paper currency in the market:',
    'ans_4.text_8': 'Convenience in transactions: If you deposit money at banks, you may be limited to transfer, withdraw money ... in 1 day, with electronic money, you have the freedom to trade regardless of space, time.',
    'ans_4.text_9': 'Cryptocurrencies cannot be counterfeited: Because they do not exist in physical form, and each cryptocurrency exists under a single sequence of encrypted bits on the Internet.',
    'ans_4.text_10': 'High security, no identity revealed when transactions anonymously.',
    'ans_4.text_11': 'Very low transaction costs.',
    'ans_4.text_12': 'Profitability is very high, especially for small value coins.',
    'ans_4.text_13': 'Safety and environmental protection.',
    'ans_4.text_14': 'Has the potential to develop e-commerce.',
    'ans_4.text_15': 'Disadvantages:',
    'ans_4.text_16': 'Besides the advantages mentioned above, there are still some disadvantages to cryptocurrencies. This causes many difficulties for users such as:',
    'ans_4.text_17': 'Using is not too easy: For those who are used to using technology, this problem is not too difficult. But for those who have little chance of exposure to technology, creating a cryptocurrency wallet and managing it is quite difficult. Not being careful is also deceived easily.',
    'ans_4.text_18': 'Cryptocurrency prices often fluctuate up and down, which is difficult to predict. This is similar to the stock market ups and downs. Traders are at risk of losing or losing capital if they do not regularly monitor fluctuations.',
    'ans_4.text_19': 'As a place for money laundering criminals: Perhaps this is the biggest downside. For the same reason, there are countries that don\'t yet accept coins as legal tender.',
    'ans_4.text_20': 'Hackers are now the primary target of hackers and are also associated with other illegal activities',
    'ans_4.text_21': 'Investing easily leads to financial bubbles on the Internet',
    'ans_4.text_22': 'What benefits will my trading be?',
    'ans_4.text_23': 'Convenient in transactions',
    'ans_4.text_24': 'Profitability is very high, especially for small value coins.',
    'ans_4.text_25': 'High security, no identity revealed when transactions anonymously.',
    'ans_4.text_26': 'Has the potential to develop e-commerce.',

    'ans_5.text_1': 'What are the conditions for doing with TrustKeys Exchange?',
    'ans_5.text_2': 'Participants performing transactions with electronic money on TrustKeys exchange need to comply with the rules, regulations and laws of virtual currency in Vietnam.',

    'ans_6.text_1': 'Coin deposit and withdraw fee',
    'ans_6.text_2': 'Trading fee for buying and selling coin = 0.5% of total transaction amount.',
    'ans_6.text_3': 'Fee for recharging the wallet',
    'ans_6.text_4': 'Fee for withdrawal of money from wallet',

    'ans_title.text_1': 'What is cryptocurrency trading?',
    'ans_title.text_2': 'How to trade on the TrustKeys exchange like?',
    'ans_title.text_3': 'How to invite friends to join the TrustKeys exchange?',
    'ans_title.text_4': 'What are the benefits of trading on the TrustKeys exchange?',
    'ans_title.text_5': 'What are the conditions for doing with TrustKeys exchange?',
    'ans_title.text_6': 'Transaction fee on the TrustKeys exchange?',

    'market.favorite': 'Favorite',
    'market.market': 'Market',
    'market.volume': 'Volume',

    deposit_fee: 'Deposit fee',
    withdrawal_fee: 'Withdrawal fee',
    free: 'Free',

    'model.cancel_order_success': 'Cancel order succeeded',
    'model.cancel_order_null': 'There are no orders in progress',

    Succeed: 'Success',
    Submitted: 'Submitted',
    Cancel: 'Cancel',
    cancel_order: 'Cancel',
    Pending: 'Pending',
    Error: 'Error',
    'Balance insufficient': 'Your balance insufficient',
    Executed: 'Executed',
    Executing: 'Executing',
    Market: 'Market',
    Stopping: 'Stopping',
    Limit: 'Limit',
    'Stop Limit': 'Stop Limit',
    'pending.order': 'Pending Order',
    Sell: 'Sell',
    Buy: 'Buy',
    Canceled: 'Canceled',
    'common.notification': 'Notification',
    'common.view_all': 'View All',
    'common.confirm': 'Confirm',
    'common.cancel': 'Cancel',
    'common.depth_chart': 'Depth chart',
    'common.empty': 'Empty',
    'common.previous': 'Previous',
    'Withdraw succeeded': 'Withdraw succeeded',

    'commission.total_receive': 'Commission received',
    'commission.total_receive_in_time_duration': 'Commissions received over a period of time',

    validate_invalid_address: 'Address invalid',
    validate_invalid_pubkey: 'Pubkey invalid',
    BLOCK_CHAIN_ADDRESS_NOT_EXIST_ERROR: 'Address invalid',

    'Add order succeeded': 'Add order succeeded',
    'Cancel order failed': 'Cancel order failed',

    'Amount invalid': 'Amount invalid',
    'View more': 'View more',

    'validate.stop_less_than': 'The stop price is less than the limit',
    'validate.stop_more_than': 'The stop price is greater than the limit price',

    greedy: 'Hello',
    Show: 'Show',
    Hide: 'Hide',

    'message.matching_order_title': 'Order Matching',
    'message.transaction_deposit_title': 'Deposit Success',
    'message.transaction_withdrawal_title': 'Withdrawal Success',
    // 'message.matching_order': 'Successful order matching at price {{price}} {{currency}} amount of {{quantity}} {{coin}} total {{amount}} {{currency}}',
    'message.matching_order': 'Successful order matching',
    'message.transaction_deposit': 'Successful remittance of {{quantity}} {{currency}}',
    'message.transaction_withdrawal': 'Successfully withdrawal {{quantity}} {{currency}} to the address {{address}}',

    'market.all': 'ALL',
    
    notification_page: 'Notifications',
    'notify_page.hide_read_notifications': 'Hide read notifications',
    'notify_page.mark_all_as_read': 'Mark all as read',
    'notify_page.clear_all': 'Clear all notifications',
    'notify_page.system_messages': 'System Messages',
    'notify_page.trade_notification': 'Trade Notifications',
    'notify_page.view_more': 'View more',
    'notify_page.confirm.mark_all_as_read': 'Are you sure to mark all as read notifications?',
    'notify_page.confirm.clear_all': 'Are you sure to clear all notifications?',
    'notify_page.confirm.ok': 'Ok',
    'notify_page.confirm.cancel': 'Cancel',
    'notify_page.empty': 'No data',

    referral: 'Giới thiệu',
    'referral.header.right.text_1.1': 'Invite Friends.',
    'referral.header.right.text_1.2': 'Earn Crypto Together',
    'referral.header.right.text_2': 'Earn up to 40% commission every time your friends make a trade on Binance.',
    'referral.header.right.button_1': 'Detailed Rules',
    'referral.header.right.button_2': 'Invite now',
    'referral.header.left.text_1': 'Default Referral ID',
    'referral.header.left.text_2': 'Default Link',
    'referral.header.left.button_1': 'Generate your link',
    'referral.header.left.note': 'Note',
    'referral.header.left.card_1': 'You Receive',
    'referral.header.left.card_2': 'Friends Receive',
    'referral.menu.link_1': 'Dashboard',
    'referral.menu.link_2': 'Your Referral Links List',
    'referral.menu.link_3': 'Friends List',
    'referral.menu.link_4': 'Commission History',
    'referral.menu.link_5': 'Commission Fees Shared With You',
    'referral.body.all_accounts': 'All Accounts',
    'referral.body.link_1.tabs_1': 'You Earned',
    'referral.body.link_1.tabs_2': 'Total Number of Traded Friends',
    'referral.body.link_1.tabs_3': 'Total Numbers of Friends',
    'referral.body.link_1.tabs_4': 'Your Ranking',
    'referral.body.link_1.text_1': "Data update time refers to UTC + 0 time zone. The data maintenance time is 3am - 5am (UTC+0) every day. During this period, the calculation of today's data is based on the assets of previous day. After maintenance, all data will be displayed properly",
    'referral.body.link_1.text_2': 'Statement: due to the complexity of financial data, there might be nuances and delay. Data displayed above is for reference only. We sincerely apologize for any inconvenience.',
    'referral.body.link_2.columns_1': 'Remaining number of promotional links to be created',
    'referral.body.link_2.columns_2': 'Referral ID',
    'referral.body.link_2.columns_3': 'You Receive / Friends Receive',
    'referral.body.link_2.columns_4': 'Note',
    'referral.body.link_2.columns_5': 'Friends',
    'referral.body.link_3.columns_1': 'Account Type',
    'referral.body.link_3.columns_2': "Friend's User ID",
    'referral.body.link_3.columns_3': 'Referral Bonus Earned (BTC)',
    'referral.body.link_3.columns_4': 'Traded',
    'referral.body.link_3.columns_5': 'Registration Time',
    'referral.body.link_4.columns_1': 'Order Type',
    'referral.body.link_4.columns_2': "Friend's User ID",
    'referral.body.link_4.columns_3': 'Commission Earned',
    'referral.body.link_4.columns_4': 'Commission Time',
    'referral.body.link_5.columns_1': 'Commission Fees',
    'referral.body.link_5.columns_2': 'Time',
    //
    'referral.withoutlogin.download': 'Scan to download',
    'referral.withoutlogin.invite.title': 'Invite your friends to Trustkeys and earn 20% on their trading fees',
    'referral.withoutlogin.invite.des':'Whether you’re a trader, HODLer, or just a die-hard Trustkeys fan, you can invite your friends to join Trustkeys and earn from their trading fees. You’ll earn 20% on your friends’ trading fees and they’ll earn 10% back. It’s a win-win.',
    'referral.withoutlogin.button':'Invite Your Friends',
    'referral.withoutlogin.work.title': 'How does it work?',
    'referral.withoutlogin.work.col_1.title' : 'Get your code',
    'referral.withoutlogin.work.col_1.des':'All Trustkeys customers can access their referral code from their account settings. Login to your Trustkeys account to find your referral code.',
    'referral.withoutlogin.work.col_2.title' : 'Invite your friends',
    'referral.withoutlogin.work.col_2.des':'Share your referral code with your friends, family, and on your social networks. Every person who signs up using your code will be another person you can earn from.',
    'referral.withoutlogin.work.col_3.title' : 'Start your earning',
    'referral.withoutlogin.work.col_3.des':'Welcome your referrals with a 10% trading fee rebate and when they trade on Trustkeys, you’ll earn 20% of the trading fees they pay, up to a maximum of 5,000 USDT.',
    'referral.withoutlogin.work.col_4.title' : 'Expand your network',
    'referral.withoutlogin.work.col_4.des':'The more you share, the more you earn. Continue sharing your referral code with your network to keep the earnings coming.',
    'referral.withoutlogin.details.title' : 'Program Details',
    'referral.withoutlogin.details.text_1' : 'Rewards will be paid out to inviters and referrals once each day in USDT.',
    'referral.withoutlogin.details.text_2' : 'Rewards are calculated based on the net spot and margin trading fees paid by referrals. For more details on how rewards are calculated, please visit our Help Center article',
    'referral.withoutlogin.details.text_3' : 'Both inviters and referrals are eligible to receive rewards for up to 180 days from the referral’s sign up date, or until the inviter and referral together have earned a combined aggregate of 5,000 USDT.',
    'referral.withoutlogin.details.text_4' : 'Each Trustkeys customer can invite as many friends as they want! There is no limit to the number of referrals one account can have.',
    'referral.withoutlogin.details.text_5' : 'Customers cannot invite themselves to earn rewards using multiple accounts. Once this behavior has been detected, you will be disqualified from the Referral Program and all unpaid earned or accrued referral rewards will be cancelled immediately.',
    'referral.withoutlogin.details.text_6' : 'Customers cannot invite accounts owned or controlled by existing Trustkeys customers. Once this behavior has been detected, you will be disqualified from the Referral Program and all unpaid earned or accrued referral rewards will be cancelled immediately.',
    'referral.withoutlogin.details.text_7' : 'We are unable to accept referrals from and cannot pay out rewards to customer accounts that are frozen, closed, or based out of a country in our prohibited countries list. For further details, please refer to our User Agreement',
    'referral.withoutlogin.details.text_8' : 'Trustkeys reserves the right to modify the rules or rewards of this Referral Program at any point by publishing an updated set of program information at https://support.poloniex.com/hc/articles/360047134473',
    'referral.withoutlogin.details.text_9' : 'For more Terms & Conditions on our Referral Program, please visit our Help Center',

    tutorial_watch_more: 'Watch more tutorials',
  },
};
